import { createContext } from "react";
import type { PortalSessionState } from "./portalSessionStorage";

/**
 * The portal-session source of truth. It is `null` without a
 * `PortalAuthProvider` above, and `usePortalSession` throws in that case, so a
 * missing provider fails immediately.
 */
export const PortalSessionContext = createContext<PortalSessionState | null>(null);
